import React, { Component, Fragment, createRef } from 'react';
import { bool, func, string, node, number, object, oneOfType, arrayOf } from 'prop-types';
import classnames from 'classnames/bind';

import styles from './AccordionItem.css';

class AccordionItem extends Component {
  static propTypes = {
    className: string,
    open: bool,
    onClick: func,
    title: oneOfType([string, object]).isRequired,
    children: node.isRequired,
    infoSection: arrayOf(object),
    secondary: bool,
    reducedSpaces: bool,
    bgGrey: bool,
    accordionId: number,
    disabled: bool
  }

  contentRef = createRef();
  contentHeight = null;

  componentDidUpdate = () => {
    this.toggleElementHeight();
  }

  componentDidMount = () => {
    this.contentHeight = `${this.contentRef.current.scrollHeight}px`;

    if (this.props.open) {
      this.toggleElementHeight();
    }
  }

  toggleElementHeight = () => {
    const { open } = this.props;

    this.contentRef.current.style.height = !open ? 0 : this.contentHeight;
  }

  handleClick = e => {
    const { onClick, accordionId } = this.props;

    onClick(e, accordionId);
  }

  handleFocus = e => {
    const element = e.currentTarget.parentNode.parentNode;

    element.classList.add(styles.focused);
  }

  handleBlur = e => {
    const element = e.currentTarget.parentNode.parentNode;

    element.classList.remove(styles.focused);
  }

  renderPrimaryTitleSection = () => {
    const { title, reducedSpaces } = this.props;
    const cx = classnames.bind(styles);

    return (
      <p className={cx(
        styles.title,
        reducedSpaces ? 'nav' : 'hotspot-title',
        {
          'reduced': reducedSpaces
        }
      )}>
        {title}
      </p>
    );
  }

  renderSecondaryTitleSection = () => {
    const { title } = this.props;

    return (
      <Fragment>
        <div className={styles.titleSection}>
          <div className={styles.titleWrapper}>
            <p className={classnames(styles.titleSecondary)}>{title.name}</p>
            <sup>
              <p className={styles.counter}>{title.counter}</p>
            </sup>
          </div>
          <p className={styles.info}>{title.info}</p>
        </div>
      </Fragment>
    );
  }

  renderInformativeSection = sections => {
    const { secondary } = this.props;
    const cx = classnames.bind(styles);

    try {
      if (!sections || !sections.length) {
        throw Error ('Your infoSection prop is empty or undefined');
      }

      if (!secondary && (sections.length > 2)) {
        throw Error (`Depending on the context, the informative sections number for primary version can vary between one and two. You have ${sections.length}`);
      }

      if (secondary && (sections.length > 3)) {
        throw Error (`Depending on the context, the informative sections number can vary between one and three. You have ${sections.length}`);
      }
    }

    catch(err) {
      console.warn(err);
      return null;
    }

    return (
      <Fragment>
        {sections.map((section, i) => (
          <div className={cx(styles.infoSection, { 'secondary': secondary })} key={i}>
            <label className={classnames(styles.label, 'label')}>
              {section.label}
            </label>
            <p className={styles.textBox}>
              {section.text}
            </p>
          </div>
        ))}
      </Fragment>
    );
  }

  render() {
    const {
      bgGrey,
      className,
      children,
      infoSection,
      reducedSpaces,
      secondary,
      open,
      disabled
    } = this.props;
    
    const cx = classnames.bind(styles);
    const classes = cx(
      'accordionItem',
      {
        'active': open,
        'secondary': secondary,
        'reduced': reducedSpaces,
        'backgroundGrey': bgGrey,
        disabled
      }
    );

    return (
      <li className={classnames(classes, className)} role={'presentation'}>
        <div className={styles.wrapper}>
          <button
            className={styles.innerTab}
            type={'button'}
            role={'tab'}
            onClick={this.handleClick}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            >
            <div>
              {
                secondary
                  ? this.renderSecondaryTitleSection()
                  : this.renderPrimaryTitleSection()
              }
            </div>
            <div>
              {!reducedSpaces && this.renderInformativeSection(infoSection)}
              <span className={cx(styles.collapseExpand, { 'reduced': reducedSpaces })} />
            </div>
          </button>
          <div ref={this.contentRef} className={styles.accordionContent}>
            {children}
          </div>
        </div>
      </li>
    );
  }
}

export default AccordionItem;



// WEBPACK FOOTER //
// ./src/uis/components/Accordion/AccordionItem/AccordionItem.js